import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import UserIcon from '@mui/icons-material/Person';
import AddRoad from '@mui/icons-material/AddRoad';
import AddUserIcon from '@mui/icons-material/PersonAdd';
import RemoveRoad from '@mui/icons-material/RemoveRoad';
import QrCodeScanner from '@mui/icons-material/QrCodeScanner';
import InfoIcon from '@mui/icons-material/Info';
import SchoolIcon from '@mui/icons-material/School';
import { useNavigate } from "react-router-dom";
import { useAuthState } from 'react-firebase-hooks/auth';
import { useState, useEffect } from 'react';
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import LocalParking from '@mui/icons-material/LocalParking';
import UploadFileIcon from '@mui/icons-material/UploadFile';

export default function NavBarAdm({ toggleDrawer }) {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUserRole = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        // Check both UID and email as document ID
        const userDocRef = doc(db, "users", user.uid);
        const emailDocRef = doc(db, "users", user.email);

        const [userDoc, emailDoc] = await Promise.all([
          getDoc(userDocRef),
          getDoc(emailDocRef)
        ]);

        let userData = null;
        if (userDoc.exists()) {
          userData = userDoc.data();
        } else if (emailDoc.exists()) {
          userData = emailDoc.data();
        }

        if (userData && userData.role) {
          setUserRole(userData.role.toLowerCase());
        }
      } catch (error) {
        console.error("Error getting user role:", error);
      } finally {
        setLoading(false);
      }
    };

    getUserRole();
  }, [user]);

  // Don't render until we know the user role
  if (loading) {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <Box>Loading...</Box>
          </Toolbar>
        </AppBar>
      </Box>
    );
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar sx={{ overflowX: "auto", whiteSpace: "nowrap" }}>
          {/* Only show UserIcon for admin */}
          {userRole === "admin" && (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2, flexShrink: 0 }}
              onClick={() => navigate("/adm_set_role")}
            >
              <UserIcon />
            </IconButton>
          )}

          {/* Show these admin/moderator menus only for admin OR moderator */}
          {(userRole === "admin" || userRole === "moderator") && (
            <>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, flexShrink: 0 }}
                onClick={() => navigate("/adm/umleitung")}
              >
                <AddRoad />
              </IconButton>

              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, flexShrink: 0 }}
                onClick={() => navigate("/adm/umleitung_del")}
              >
                <RemoveRoad />
              </IconButton>

              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, flexShrink: 0 }}
                onClick={() => navigate("/adm/add_plans")}
              >
                <UploadFileIcon />
              </IconButton>

              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, flexShrink: 0 }}
                onClick={() => navigate("/adm/addinfo")}
              >
                <InfoIcon />
              </IconButton>

              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, flexShrink: 0 }}
                onClick={() => navigate("/adm/qr")}
              >
                <QrCodeScanner />
              </IconButton>

              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, flexShrink: 0 }}
                onClick={() => navigate("/adm/handys_schule")}
              >
                <SchoolIcon />
              </IconButton>
            </>
          )}

          {/* BUS PARK - visible to admin, moderator and hofdienst */}
          {(userRole === "admin" || userRole === "moderator" || userRole === "hofdienst") && (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2, flexShrink: 0 }}
              onClick={() => navigate("/adm/bus_park")}
            >
              <LocalParking />
            </IconButton>
          )}

        </Toolbar>
      </AppBar>
    </Box>
  );
}